
import { getIdFromUrl } from 'vue-youtube'

export default {
  props: {
    url: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      videoIsReady: false,
      playing: false,
      videoThumbnail: null,
    }
  },

  computed: {
    videoId() {
      return getIdFromUrl(this.url)
    },
  },

  mounted() {
    if (this.url) {
      this.videoThumbnail = `https://img.youtube.com/vi/${this.videoId}/maxresdefault.jpg`
      this.getImgWidth().then((imageWidth) => {
        // sometimes the youtube max res image is not available
        // it will return instead an error image that has a width of exaclty 120
        // when it returs that error image it should get instead the hqdefault image
        if (imageWidth === 120) {
          this.videoThumbnail = `https://img.youtube.com/vi/${this.videoId}/hqdefault.jpg`
        }
      })
    }
  },

  methods: {
    playVideo() {
      this.$refs.youtube.player.playVideo()
    },

    getImgWidth() {
      return new Promise((resolve) => {
        const newImg = new Image()
        newImg.onload = function () {
          resolve(newImg.width)
        }
        newImg.src = this.videoThumbnail
      })
    },
  },
}
